import React from 'react'
import { SankeyDiagram, Upload, Tree } from '@carbon/icons-react'
import { Stack, DatePicker, DatePickerInput, Button, Tabs, Tab, TabList, TabPanels, TabPanel } from '@carbon/react'
import { CardComponent } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card';
import Typography from '../../../components/Basics/Typography'
import { g100 } from '@carbon/themes';
import AljibeTree from './KpiTreeAljibes.container'
import PlumaTree from './KpiTreePluma.container'

/**
 * The Map's Page.
 */
const KpiTreeContainer = () => {

    const marginBottom = '0 0 20px'
    const wordPadding = '0 40px'

    return (
            <Stack gap={3}>
                <CardComponent width="100%">
                    <Card $justifyContent='flex-start'>
                        <SankeyDiagram size={18} />
                        <Typography className='cds--type-heading-compact-01'>
                            ARBOL DE KPI
                        </Typography>
                    </Card>
                    <Card alignItems='flex-start' $padding="4px">
                        <Card width="100%" height="100%" background={g100.background} flexDirection='column' alignItems='flex-start' $padding='30px'>
                            <DatePicker datePickerType="range" dateFormat='d/m/Y'>
                                <DatePickerInput id={`date-picker-input-id-start`} placeholder="dd/mm/aaaa" labelText="Fecha de Inicio" size="md" />
                                <DatePickerInput id={`date-picker-input-id-finish`} placeholder="dd/mm/aaaa" labelText="Fecha de Término" size="md" />
                            </DatePicker>
                            <Button renderIcon={Upload} iconDescription="Cargar datos al arbol" size='sm'>Cargar datos al árbol</Button>
                            <Tabs>
                                <TabList activation="manual" aria-label="List of tabs">
                                    <Tab renderIcon={Tree}>Árbol de Aljibes</Tab>
                                    <Tab renderIcon={Tree}>Árbol de Camiones Pluma</Tab>
                                </TabList>
                                <TabPanels>
                                    <TabPanel style={{ width: '100%' }}>
                                        <AljibeTree marginBottom={marginBottom} wordPadding={wordPadding} />
                                    </TabPanel>
                                    <TabPanel style={{ width: '100%' }}>
                                        <PlumaTree marginBottom={marginBottom} wordPadding={wordPadding} />
                                    </TabPanel>
                                </TabPanels>
                            </Tabs>
                        </Card>
                    </Card>
                </CardComponent>
            </Stack>
    )
}

export default KpiTreeContainer
